const { nftCache } = require('./cache');
module.exports = {
    getTransaction: function(id, callback, network){
        function loader(res, o, id, callback){
            const records = (o._embedded && o._embedded.records) || o.records;
            if(records.length === 0){
                return callback({data: res});
            } else {
                res.ops = res.ops.concat(records);
                return loadOperations(res, o, id, callback);
            }
        }
    
        function loadOperations(res, ops, id, callback){
            if(ops === null || ops === undefined){
                return res.operations().then((o)=>{return loader(res, o, id, callback)}).catch((err)=>{
                    console.log(err);
                    return callback({error: 'Operations for Transaction #' + id + ' not found', data: res});
                });
            } else {
                return ops.next().then((o)=>{return loader(res, o, id, callback)}).catch((err)=>{
                    console.log(err);
                    return callback({error: 'Operations for Transaction #' + id + ' not found', data: res});
                });
            }
        }

        return network.getTransaction(id,
            (res)=>{
                res.ops = [];
                return loadOperations(res, null, id, callback);
            },
            (err)=>{
                callback({error: 'Transaction #' + id + ' not found'});
            }
        );
    },

    getAddress: function(id, callback, network){
        return network.getAccount(id,
            (res)=>{
                network.getAccountTransactions(id,(txs)=>{
                    res.txs = txs.records;
                    Promise.all(txs.records.map((t)=>{
                        return network.getTransactionOperationsPromise(t.hash);
                    })).then((ops)=>{
                        ops.forEach((o)=>{
                            res.txs = res.txs.map((t)=>{
                                if(t.hash === o.records[0]._links.transaction.href.split('/').pop()){
                                    t.ops = o.records;
                                }
                                return t;
                            })
                        });
                        callback({data: res});
                        return null;
                    }).catch((err)=>{
                        console.log(err);
                        callback({error: 'Operations for transactions for account #' + id + ' not found', data: res});
                    });
                    return null;
                },(err)=>{
                    console.log(err);
                    callback({error: 'Transactions for account #' + id + ' not found', data: res});
                });
                return null;
            },
            (err)=>{
                console.log(err);
                callback({error: 'Address #' + id + ' not found'});
            }
        );
    },

    getAccountData: function(id, network) {
        return new Promise((resolve, reject) => {
            network.getAccount(id, (res) => {
                nftCache[id] = res.data_attr;
                resolve(res.data_attr);
            }, (err) => {
                console.log(err);
                reject({ error: 'Address #' + id + ' not found' });
            });
        });
    },

    getSequence: function(id, callback, network){
        return network.getLedger(id,
            (res)=>{
                if(res.successful_transaction_count > 0){
                    return network.getLedgerTransactions(id, res.successful_transaction_count, (txs)=>{
                        res.txs = txs.records;
                        Promise.all(txs.records.map((t)=>{
                            return network.getTransactionOperationsPromise(t.hash);
                        })).then((results)=>{
                            results.forEach((o)=>{
                                res.txs = res.txs.map((t)=>{
                                    if(t.hash === o.records[0]._links.transaction.href.split('/').pop()){
                                        t.ops = o.records;
                                    }
                                    return t;
                                })
                            })
                            callback({data: res});
                            return null;
                        }).catch((err)=>{
                            console.log(err)
                            callback({error: 'Operations for transactions for ledger #' + id + ' not found', data: res});
                        });
                        return null;
                    },(err)=>{
                        console.log(err)
                        callback({error: 'Transactions for ledger #' + id + ' not found', data: res});
                    });
                } else {
                    callback({data: res});
                }
            },
            (err)=>{
                callback({error: 'Ledger #' + id + ' not found'});
            }
        );
    },

    getLedgers: function(callback, network){
        return network.getLastLedgers(
            (data)=>{
                return callback({data:data});
            },
            (error)=>{
                console.log(error);
                return callback();
            }
        );
    },

    getLiquidityPool: function(id, callback, network){
        return network.getLiquidityPool(
            id, 
            (data)=>{
                return callback({data:data});
            },
            (error)=>{
                console.log(error);
                return callback();
            }
        );
    },

    getTransactions: function(callback, network){
        return network.getOperations(
            (data)=>{
                data.records = data.records.map(o=>{
                    o.hash = o._links.transaction.href.split('/').pop();
                    return o;
                });
                return Promise.all(data.records.map((o)=>{
                    return network.getTransactionPromise(o.hash);
                })).then((results)=>{
                    results.forEach((res)=>{
                        data.records = data.records.map((o)=>{
                            if(res.hash === o.hash){
                                o.created_at = res.created_at;
                            }
                            return o;
                        });
                    });
                    return callback({data:data});
                }).catch(error=>{
                    console.log(error);
                    return callback();
                });
            },
            (error)=>{
                console.log(error);
                return callback();
            }
        );
    },

    getStats: function(callback, network){
        return network.getHistory(
            (data)=>{
                return callback({data:data});
            },
            (error)=>{
                console.log(error);
                return callback();
            }
        );
    }
}


// WEBPACK FOOTER //
// ./src/fetch.js